import * as mustcache from "mustcache";
import * as webReaderInstaller from "webReaderInstaller";

class WebReaderPage {
  name = "webReader";
  showHeader = true;

  render(element, renderedCallback) {
    element.html(mustcache.render("webReaderPage", {}));
    webReaderInstaller.render(element.find(".webReaderInstaller"), {
      forceShowChromeExtension: true,
    });
    renderedCallback();
  }
}

export default WebReaderPage;
